module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5LXe1"))).then(() => parcelRequire('d0iPb'));